<template lang="html">

<div class="buildingList">

      <!-- 查看 -->
      <el-row class="seekLine">

         <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6" class="inpItem">

              <div class="inpName">楼宇名称：</div>
              <div class="inpContent">
                   <el-input clearable @input="reList" v-model="params.buildingName" size="medium" placeholder="请输入内容" />
              </div>

         </el-col>

         <el-col v-if="type==1" :xs="24" :sm="24" :md="12" :lg="8" :xl="6" class="inpItem">

              <div class="inpName">所在街乡：</div>
              <div class="inpContent">
                   <tree-select code="szjx"
                        paramsKey="jiexiang"
                        :moreSelect="true"
                        :selectId="params.jiexiang"
                        @selectChange="selectChange"
                        plaText="所在街乡" />
              </div>

         </el-col>

         <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6" class="inpItem">

              <div class="inpName">定位：</div>
              <div class="inpContent">
                   <dic-select code="dw"
                        paramsKey="location"
                        :selectId="params.locationId"
                        @selectChange="selectChange"
                        plaText="定位" />
              </div>

         </el-col>

          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6" class="inpItem">

              <div class="inpName">所属功能区：</div>
              <div class="inpContent">
                   <dic-select code="ssgnyq"
                      paramsKey="park"
                      :selectId="params.parkId"
                      plaText="所属功能区"
                      @selectChange="selectChange" />
              </div>

         </el-col>

         <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6" class="inpItem">

              <div class="inpName">当前空置可招商面积：</div>
              <div class="inpContent">
                <el-select clearable @change="areaChange" v-model="areaKey" size="medium" placeholder="请选择">
                   <el-option
                     v-for="item in areaOptions"
                     :key="item.val"
                     :label="item.name"
                     :value="item.val">
                   </el-option>
                 </el-select>
              </div>

         </el-col>

         <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6" class="inpItem">

              <div class="inpName">项目类型：</div>
              <div class="inpContent">
                    <dic-select code="xmlx"
                        :selectId="params.projectTypeId"
                       paramsKey="projectType"
                       plaText="项目类型"
                       @selectChange="selectChange" />
              </div>

         </el-col>
         <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6" class="inpItem">
              <div class="inpContent">
                  <!-- <el-button v-if="type==1" @click="excelHandle" style="width:80px;"  size="small">导入Excel</el-button> -->
                  <el-button @click="exCreate" style="width:80px;" size="small">导出</el-button>
                  <el-button @click="cleanSeek" style="width:80px;" size="small">重置</el-button>
              </div>
        </el-col>


      </el-row>

      <div class="pgContent">

           <el-table border
               v-loading="loading"
               header-cell-class-name="dHead"
               :data="tbData">

               <el-table-column fixed="left" align="center" width="60" label="序号">
                   <template slot-scope="scope">
                        {{ scope.$index + (params.no - 1)*params.size + 1 }}
                   </template>
               </el-table-column>
               <el-table-column prop="buildingName" fixed="left" align="center" min-width="150" label="楼宇名称" />
               <el-table-column prop="tenement" align="center" width="120" label="物业单位" />
               <el-table-column prop="propertyUnit" align="center" min-width="120" label="产权单位" />
               <el-table-column prop="jiexiang" align="center" width="90" label="所在街乡" />
               <el-table-column prop="propertyUnit" align="center" min-width="150" label="地址" />
               <el-table-column prop="park" align="center" width="150" label="所属功能区" />
               <el-table-column prop="projectType" align="center" width="120" label="项目类型" />
               <el-table-column prop="nationalized" align="center" width="120" label="是否国有" />
               <el-table-column prop="location" align="center" width="120" label="产业定位" />
                <el-table-column prop="isWillingCityPlatformReleaseRecommend" align="center" width="150" label="是否愿意在市级平台对外发布推介" />
               <el-table-column prop="isWillingDistrictInvestmentWorkeleaseRecommend" align="center" width="120" label="是否愿意在区级招商工作中对外发布推介" />
               <el-table-column prop="notPublishReason" align="center" width="120" label="不希望对外发布的原因" />
               <el-table-column prop="isWillingUndertakeInterOrganizationWorkspace" align="center" width="120" label="是否愿意承接国际组织办公场所" />
               <el-table-column prop="planBuildingArea" align="center" width="120" label="规划建筑面积(平方米)" />
               <el-table-column prop="totalVacantArea" align="center" width="150" label="当前空置可招商面积(平方米)" />
               
               <el-table-column prop="leadingCadre" align="center" width="120" label="招商负责人" />
               <el-table-column prop="leadingCadrePhone" align="center" width="150" label="负责人手机号" />
               <el-table-column prop="leadingCadreEmail" align="center" width="120" label="负责人邮箱" />
               
               <el-table-column align="center" width="120" label="图片">
                   <template slot-scope="scope">
                       <span @click="goview(scope.row)" class="ibtn">查看</span>
                   </template>
               </el-table-column>
               <el-table-column prop="uploadUser" align="center" width="90" label="上传用户" />
               <el-table-column prop="createdAt" align="center" width="150" label="上传时间" />
               <!-- 编辑 -->
               <el-table-column align="center" width="80" fixed="right" label="操作">
                   <template slot-scope="scope">
                        <span @click="goInner(scope.row.id)" class="ibtn">查看</span>
                   </template>
               </el-table-column>

           </el-table>

           <div class="table-footer">

              <el-pagination
                class="paging"
                v-if="allPages>1"
                @current-change="currentChange"
                :current-page="params.no"
                :page-size="params.size"
                layout="total, prev, pager, next, jumper"
                :total="params.allEls">
              </el-pagination>

          </div>



      </div>

      <el-image
        ref="elImage"
        style="width: 0px; height: 0px"
        :src="url"
        :preview-src-list="srcList"
      />

      <div class="ECArea">
           <ECdomPre ref="ChildEx"></ECdomPre>
      </div>
        <ExcelIn ref="ExcelSet" @onSuccess="importSuccess" />
        <ExError ref="chinldError" :errorList="excelEr" :tableHeader="excelErrorTableHeader"></ExError>
</div>

</template>

<script>
import { getBuildings } from '@/api/industryInfos';
import ECdomPre from './ECdomPre';
import { getViewKey } from '@/api/account';
import { mapGetters } from 'vuex';
import ExcelIn from '@/views/components/excelRead/excel';
import ExError from '@/views/components/excelRead/excelError';
import { importIndustrialSpaces,getErrorImportLog } from '@/api/industryInfos';
export default {
    components:{
        ECdomPre,
        ExcelIn,
        ExError
    },
    props:['type'],
    computed:{
      ...mapGetters(['userInfo'])
    },
    data(){
        return{
            tbData:[],
            areaOptions:[
               { name:'不限',val:0 },
               { name:'1000 ㎡以下',val:1 },
               { name:'1000-3000 ㎡',val:2 },
               { name:'3000-5000 ㎡',val:3 },
               { name:'5000-10000 ㎡',val:4 },
               { name:'10000-30000 ㎡',val:5 },
               { name:'30000-50000 ㎡',val:6 },
               { name:'50000 ㎡以上',val:7 }
            ],
            areaKey:null,

            loading:false,

            allPages:0,
            jxids:[],
            params:{
                buildingName:'',
                jiexiangId:'',
                locationId:'',
                parkId:'',
                totalVacantArea1:'',
                totalVacantArea2:'',
                projectTypeId:'',
                orgId:'',
                status:2,
                no:1,
                size:10,
                allEls:0
            },
            viewDat:null,
            url:'',
            srcList:[],
            excelloading:{},
            excelEr:[],
            excelErrorTableHeader:[
                {'name':'楼宇招商名称','dataName':'buildingName'},
                {'name':'物业单位','dataName':'tenement'},
                {'name':'产权单位','dataName':'propertyUnit'},
                {'name':'所属街乡','dataName':'jiexiang'},
                {'name':'所属功能区','dataName':'park'},
                {'name':'地址','dataName':'address'},
                {'name':'项目类型','dataName':'projectType'},
                {'name':'是否国有','dataName':'nationalized'},
                {'name':'产业定位','dataName':'location'},
                {'name':'是否愿意在市级平台对外发布推介','dataName':'isWillingCityPlatformReleaseRecommend'},
                {'name':'是否愿意在区级招商工作中对外发布推介','dataName':'isWillingDistrictInvestmentWorkeleaseRecommend'},
                {'name':'不对希望外发布的原因','dataName':'notPublishReason'},
                {'name':'是否愿意承接国际组织办公场所','dataName':'isWillingUndertakeInterOrganizationWorkspace'},
                {'name':'规划建筑面积（平方米）','dataName':'planBuildingArea'},
                {'name':'当前空置可招商面积（平方米）','dataName':'totalVacantArea'},
                {'name':'报价（元/天/平方米）','dataName':'price'},
                {'name':'是否出售','dataName':'isSell'},
                {'name':'招商负责人','dataName':'leadingCadre'},
                {'name':'负责人手机号','dataName':'leadingCadrePhone'},
                {'name':'邮箱','dataName':'leadingCadreEmail'},
                {'name':'其他','dataName':'other'},
                {'name':'匹配上传用户','dataName':'uploadUser'},
            ],
        }
    },
    methods:{
        selectChange(e){
           this.params[e.paramsKey + 'Id'] = e.id;
           this.reList();
        },
        excelHandle:function(){
            this.$refs.ExcelSet.handleUpload();
        },
        // errorCtrls:function(val){
        //     this.excelEr = val;
        //     this.$refs.chinldError.handErrors();
        // },
        areaChange(e){
            console.log(e);
           let map = {
               1: [0,1000],
               2: [1000,3000],
               3: [3000,5000],
               4: [5000,10000],
               5: [10000,30000],
               6: [30000,50000],
               7: [50000,'']
           }
           if(e){
             this.params.totalVacantArea1 = map[e][0];
             this.params.totalVacantArea2 = map[e][1];
           }else{
             this.params.totalVacantArea1 = '';
             this.params.totalVacantArea2 = '';
           }
           this.areaKey=e;
           this.reList();
        },
        // goFresh:function(){
        //     // this.tabSeek('init');
        // },
        cleanSeek(){
           let arr = ['buildingName','jiexiangId','jiexiang','locationId','parkId','totalVacantArea1','totalVacantArea2','projectTypeId'];
           arr.forEach(item => {
               this.params[item] = '';
           });
           this.jxids = [];
           this.areaKey=null;
           this.reList();
        },
        importSuccess(data){
            this.excelloading = this.$loading({
                lock: true,
                text: '导入中，请耐心等候...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            var vm=this;
            console.log(data);
            var post = {};
            post.importIndustrialSpaceList = data;
            importIndustrialSpaces(post).then(response => {
                console.log('importIndustrialSpaces',response);
                getErrorImportLog({batchNum:response.batchNum}).then(response => {
                    console.log('getErrorImportLog',response);
                    if(response.importLogList.length>0){
                        vm.excelEr = response.importLogList;
                    }
                    vm.reList();
                    vm.excelloading.close();
                    // for(var t in response.importLogList){
                    //         if(response.importLogList[t].message){
                    //             errorDatas.push(response.importLogList[t]);
                    //         }
                    // };
                 
                    // resolve(errorDatas);
                }).catch(error => {
                    // reject(error);
                })
            }).catch(error => {
                // reject(error);
            })
            
        },
        currentChange(e){
           this.params.no = e;
           this.getList();
        },

        getList(){
            this.loading = true;
            this.jxids.length > 0 ? this.params.jiexiangId = this.jxids.join(',') : '';
            if(this.type==2){
              this.params.orgId=this.userInfo.orgId;
           }
            getBuildings(this.params).then(res => {
                this.loading = false;
                this.tbData = res.industrialSpaceList;
                this.params.allEls = res.totalElements;
                this.allPages = res.totalPages;
            })
        },

        reList:function(){
            this.params.no = 1;
            this.getList();
        },

        exCreate:function(){
            if(this.params.allEls > 0){
                this.$refs.ChildEx.metIDAsk(this.params,1);
            }else{
                this.$message.error('当前无数据可导出！');
            }

        },

        goview(row){
            if(this.viewDat){
                let vues = this;

                if(row.image){
                   let imgs = JSON.parse(row.image);
                   vues.srcList = [];
                   imgs.forEach(item => {
                       let url = vues.viewDat.imagePreUrl + '/id/' + item.id + '/token/' + vues.viewDat.token;
                       vues.srcList.push(url);
                   });
                   vues.$nextTick(() => {
                       vues.$refs.elImage.clickHandler();
                   })
                }
            }else{
               this.$message.error('初始化未完成！');
            }
        },

        goInner(id){
            this.$router.push({
                path:'bulidingInfos',
                query:{
                    id,
                    from:'view'
                }
            });
        }
    },
    created(){
        
        getViewKey().then(res => {
            this.viewDat = {
                imagePreUrl:res.imagePreUrl,
                token:res.token
            };
            this.getList();
        })
       
    }
}
</script>

<style lang="scss" scoped>

.buildingList{
    font-size: 15px;

    .headLine{
        padding: 0 20px;
        height: 60px;
        line-height: 60px;
        border-bottom: 1px solid #EBEEF5;
    }
    
    .navLine{
       padding-left: 20px;
       border-bottom: 1px solid #EBEEF5;
       .navItem{
           height: 54px;
           font-size: 14px;
           margin-left: 30px;
           display: inline-block;
           line-height: 54px;
           border-bottom: 2px solid white;
           cursor: pointer;
           &.act{
              color: #409EFF;
              border-color: #409EFF;
           }
       }
    }
    .seekLine{
        padding: 20px;
        padding-bottom: 16px;
        border-bottom: 1px solid #EBEEF5;
        .inpItem{
            padding-right: 20px;
            margin-bottom: 20px;
            .inpName{
                width: 140px;
                float: left;
                font-size: 14px;
                text-align: right;
                padding-top: 6px;
            }
            .inpContent{
                margin-left: 140px;
                .el-select{
                    display: block;
                }
                .el-cascader{
                    display: block;
                }
            }
            .btnContent{
             
                .el-select{
                    display: block;
                }
                .el-cascader{
                    display: block;
                }
            }
        }
        
    }

    .btnLine{
        padding: 20px;
        padding-bottom: 0px;
    }

    .ECArea{
        display: none;
    }

    .pgContent{
         padding: 20px;


        .table-footer{
            margin-top: 20px;
            text-align: right;
        }

        .ibtn{
            cursor: pointer;
            font-size: 13px;
            margin: 0 3px;
        }

        .ibtn:nth-child(1){
            color: #409EFF;
        }
        .ibtn:nth-child(2){
            color: #E6A23C;
        }
        .ibtn:nth-child(3){
            color: #F56C6C;
        }
    }

}

</style>

<style lang="scss">

#buildings{

    .el-input__inner{
        border-radius: 0px;
    }

    .dHead{
        background: #f5f5f5;
        font-weight: normal;
    }

}

</style>



// WEBPACK FOOTER //
// buildingList.vue?6b4f6003